/* TODO: Unfortunately, this will be loaded every time the app loads. It's placed
 *        here alongside a controller in the hopes that someday we'll have the ability
 *        to progressively load JS controller code based on when data-controller="controller"
 *        is invoked, same as the connecting controller. */
import "@lottiefiles/lottie-player"
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.playIcon = this.data.get('play-icon') || 'circled-black-right-pointing-iscoceles-triangle'
    this.pauseIcon = this.data.get('pause-icon') || 'circled-black-double-vertical-bars'
    
    this.lottiePlayer = null
    this.isPlaying = false
    this.button = null
    
    this.initializeLottiePlayer()
  }

  initializeLottiePlayer() {
    // Find the lottie-player element within this controller's scope
    this.lottiePlayer = this.element.querySelector('lottie-player')
    this.button = this.element.querySelector('[data-lottie-button]')
    
    if (!this.lottiePlayer) {
      setTimeout(() => this.initializeLottiePlayer(), 100)
      return
    }
    
    // Wait for the lottie-player to be fully loaded
    if (!this.lottiePlayer.getLottie) {
      setTimeout(() => this.initializeLottiePlayer(), 100)
      return
    }
    
    // Set up event listeners for animation state changes
    this.lottiePlayer.addEventListener('ready', () => {
      this.isPlaying = true // Lottie starts with autoplay
      this.updateButtonState()
    })
    
    this.lottiePlayer.addEventListener('play', () => {
      this.isPlaying = true
      this.updateButtonState()
    })
    
    this.lottiePlayer.addEventListener('pause', () => {
      this.isPlaying = false
      this.updateButtonState()
    })
    
    this.lottiePlayer.addEventListener('complete', () => {
      if (!this.lottiePlayer.hasAttribute('loop')) {
        this.isPlaying = false
        this.updateButtonState()
      }
    })
    
    // Check if the animation is already playing
    if (this.lottiePlayer.getLottie() && !this.lottiePlayer.getLottie().isPaused) {
      this.isPlaying = true
    }
    
    this.updateButtonState()
  }

  togglePlayPause() {
    if (!this.lottiePlayer) return

    if (this.isPlaying) {
      this.lottiePlayer.pause()
    } else {
      this.lottiePlayer.play()
    }
  }

  updateButtonState() {
    if (!this.button) return
    
    const iconElement = this.button.querySelector('sl-icon')
    if (!iconElement) return
    
    if (this.isPlaying) {
      iconElement.setAttribute('name', this.pauseIcon)
      this.button.setAttribute('aria-label', 'Pause animation')
    } else {
      iconElement.setAttribute('name', this.playIcon)
      this.button.setAttribute('aria-label', 'Play animation')
    }
  }

  disconnect() {
    if (this.lottiePlayer) {
      this.lottiePlayer.removeEventListener('ready', this.updateButtonState)
      this.lottiePlayer.removeEventListener('play', this.updateButtonState)
      this.lottiePlayer.removeEventListener('pause', this.updateButtonState)
      this.lottiePlayer.removeEventListener('complete', this.updateButtonState)
    }
  }
}
